import axios from "axios";
import {
  ADMIN_LOGIN_FAIL,
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGOUT,
} from "../constants/adminConstant";
import { BASE_URL } from "../constants/baseUrl";
import { setAuthHeader } from "../utils/auth";

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_LOGIN_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      `${BASE_URL}/login`,
      { email, password },
      config
    );
    if (!data || !data.token) {
      throw new Error("Login failed: no token received from the server.");
    }
    setAuthHeader(data.token);
    dispatch({ type: ADMIN_LOGIN_SUCCESS, payload: data });

    localStorage.setItem("adminInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: ADMIN_LOGIN_FAIL,
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
  }
};

export const logout = () => (dispatch) => {
  setAuthHeader(null);
  dispatch({ type: ADMIN_LOGOUT, payload: null });
};
